<section class="circle-gradient overflow-hidden">
  <div class="breadcrumb-sec event-sec">
    <div class="container">
      <div class="row g-0">
        <div class="col-md-6">
          <ul class="breadcrumb">
            <li><a href="https://raisoni.net/">Home</a></li>
            <li><i class="fa fa-angle-right"></i></li>
            <li><a href="events-new">Events</a></li>
            <li><i class="fa fa-angle-right"></i></li>
            <li><a href="events-new#academic">Academic</a></li>
            <li><i class="fa fa-angle-right"></i></li>
            <li>RAHE – Raisoni Academy for Human Excellence program</li>
          </ul>
          <div class="sec-title">
            <h1>
              <span>RAHE – Raisoni Academy for Human Excellence program</span>
            </h1>
            <p>
              RAHE – Raisoni Academy for Human Excellence at Mangalwari Campus
              successfully conducted a Faculty Development Program aimed at
              enhancing teaching excellence and professional growth. Chairman
              Sir, Mr. Sunil Raisoni, graced the occasion and shared his
              valuable insights, inspiring faculty members to continuously
              evolve and innovate. The program focused on modern pedagogical
              practices, skill enhancement, and academic excellence. Raisoni
              Education continues to deliver the best by empowering its
              educators.
            </p>
          </div>
        </div>
        <div class="breadcrumb-overlay overflow-hidden" style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-1.webp);
          "></div>
      </div>
    </div>
  </div>
</section>

<div class="section-lg">
  <div class="container">
    <div class="sec-title text-center">
      <h2><span>Photo Gallery</span></h2>
    </div>
    <div class="demo-gallery photo-gallery">
      <ul class="lightgallery">
        <li class="grid-item1"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-2.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-2.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-2.webp" />
          </a>
        </li>
        <li class="grid-item2"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-3.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-3.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-3.webp" />
          </a>
        </li>
        <li class="grid-item3 d-none d-lg-block d-md-block"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-4.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-4.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-4.webp" />
          </a>
        </li>
        <li class="grid-item4"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-5.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-5.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-5.webp" />
          </a>
        </li>
        <li class="grid-item5"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-6.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-6.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-6.webp" />
          </a>
        </li>
        <li class="grid-item6 d-none d-lg-block d-md-block"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-1.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-1.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-1.webp" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
